import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {DataService} from './data.service'
import * as firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/database";


@Injectable({
  providedIn: 'root'
})
export class IndexresolveService implements Resolve<any>{
z:Observable<any>;

  constructor(private dataa:DataService) { }
   resolve (route:ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>{

    let picture =   this.dataa.returnee('pictures');
    let faculties =  this.dataa.returnee('faculties');
    let employees =  this.dataa.returnee('employees');
    let writtencontact =  this.dataa.returnee('writtencontact');

    return this.dataa.returnee("");


}
}
